import React from 'react'
import { useEffect } from "react";


import Hero from '../Components/Header/Hero'
import SoftwareDetails from '../Components/SoftwareDetails/SoftwareDetails';
import ExplanatoryVideo from '../Components/ExplanatoryVideo/ExplanatoryVideo'
import Testimonial from '../Components/Testimonial/Testimonial';
import Client from '../Components/Client/Client';
import Pricing from '../Components/Pricing/Pricing';

import AOS from 'aos';
import 'aos/dist/aos.css'

const Home = () => {


    useEffect(() => {
        document.title = "Pressing 360 : Votre outil indispensable pour un pressing moderne et performant.";
        AOS.init({ duration: 800 })
    }, []);
    return (
        <>
            <div id='hero' >
                <Hero />
            </div>
            <div id="softwaredetails" >
                <SoftwareDetails />
            </div>
            <div id="explanatoryvideo">
                <ExplanatoryVideo /> 
            </div>
            <div id="client">
                <Client />
            </div>
            <div id="pricing">
                <Pricing />
            </div>
            <div id="testimonial">
                <Testimonial />
            </div>

        </>
    )
}

export default Home

